// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__Izh04","suffix":"icon_suffix__DclLs","prefix":"icon_prefix__YxQ9l"};